import { ColladaExporter } from 'three/examples/jsm/exporters/ColladaExporter';
import { ThreeView } from "../View3dWebCad";

class ExportCollada {

    // gltf exporter
    public export() {
        const scene = ThreeView.get().wcScene.me;
        const exporter = new ColladaExporter();

        const link = document.createElement( 'a' );
        link.style.display = 'none';
        document.body.appendChild( link ); // Firefox workaround, see #6594

        const save = ( blob, filename ) => {
            link.href = URL.createObjectURL( blob );
            link.download = filename;
            link.click();
        }

        const saveString = ( text, filename ) => {
            save( new Blob( [ text ], { type: 'text/plain' } ), filename );
        }

        const visible = (name, flag) => {
            const object = scene.getObjectByName(name);
            if (object) object.visible = flag;
        }

        visible("空", false);
        visible("グリッド線", false);
        visible("雲", false);

        const options = {
          trs: true,
          onlyVisible: true,
        };
        const data = exporter.parse(
          scene,
          null,
          null
        );
        saveString( data, 'scene.dae' );

        visible("空", true);
        visible("グリッド線", true);
        visible("雲", true);
    }
}

export { ExportCollada };
